import { Configuration, LogLevel, PopupRequest, RedirectRequest } from '@azure/msal-browser';

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID || 'd0176acb-fb1a-4c73-89b5-737ef9445ae3',
    authority: 'https://login.microsoftonline.com/common/v2.0',
    redirectUri: process.env.REACT_APP_MICROSOFT_REDIRECT_URI || `${window.location.origin}/oauth/callback`,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues with IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Info,
    },
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ['openid', 'profile', 'email', 'User.Read'],
};

// Add scopes here for access token to be used at Microsoft Graph API endpoints.
export const graphRequest = {
  scopes: ['User.Read'],
};

// Popup configuration for login
export const popupLoginRequest: PopupRequest = {
  ...loginRequest,
  prompt: 'select_account',
};

// Redirect configuration for login
export const redirectLoginRequest: RedirectRequest = {
  ...loginRequest,
  prompt: 'select_account',
};
